import { render, staticRenderFns } from "./proright.vue?vue&type=template&id=1a007342&"
import script from "./proright.vue?vue&type=script&lang=js&"
export * from "./proright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports